export default class User {
  constructor(data: {
    id: any;
    firstName: any;
    lastName: any;
    companyName?: string;
    roles: any;
    email: any;
    subscriptions: any;
    emailConfirmed: boolean;
  }) {
    this.setData(data);
  }

  setData(data: {
    id: any;
    firstName: any;
    lastName: any;
    companyName?: string;
    roles: any;
    email: any;
    emailConfirmed: boolean;
  }) {
    const {
      id,
      firstName,
      lastName,
      companyName,
      roles,
      email,
      emailConfirmed,
    } = data;
    if (id) {
      this.id = id;
    }

    if (firstName) {
      this.firstName = firstName;
    }

    if (lastName) {
      this.lastName = lastName;
    }

    if (companyName) {
      this.companyName = companyName;
    }

    if (email) {
      this.email = email;
    }

    if (emailConfirmed) {
      this.emailConfirmed = emailConfirmed;
    }

    if (roles && roles.length) {
      this.roles = roles;
    }
  }

  get fullName() {
    if (this.firstName === null) {
      return "";
    }

    return `${this.firstName} ${this.lastName}`;
  }

  id = "";
  roles: Array<string> = [];
  firstName = "";
  lastName = "";
  companyName?: string;
  email = "";
  emailConfirmed = false;
  activeSubscription = false;
}
